(() => {

    document.addEventListener("DOMContentLoaded", () => {

        document
            .querySelectorAll("[data-quick-variant-link]")
            .forEach(container => {

                const productUrl =
                    container.dataset.productUrl ||
                    container.querySelector("[data-product-url]")?.dataset.productUrl ||
                    container.closest(".product-card")
                        ?.querySelector(".product-card__link")
                        ?.href;

                if (!productUrl)
                    return;

                container.style.cursor = "pointer";

                container.onclick = () => {

                    window.location.href = productUrl;

                };

            });

    });

})();